import { render, staticRenderFns } from "./cjsd.vue?vue&type=template&id=71ff88a6&scoped=true"
import script from "./cjsd.vue?vue&type=script&lang=js"
export * from "./cjsd.vue?vue&type=script&lang=js"
import style0 from "./cjsd.vue?vue&type=style&index=0&id=71ff88a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff88a6",
  null
  
)

export default component.exports